import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Typography, TextField, Alert, Box, Card, CardContent, IconButton } from '@mui/material';
import { useAuth } from '../auth/Auth';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const UserProfiles = () => {
    const [usersByContractor, setUsersByContractor] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [editingUser, setEditingUser] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [saveError, setSaveError] = useState('');
    const [saveSuccess, setSaveSuccess] = useState('');
    const [expandedContractor, setExpandedContractor] = useState(null);
    
    const { user } = useAuth();
  
    useEffect(() => {
      fetchUsersGrouped();
    }, []);
  
    const fetchUsersGrouped = async () => {
      try {
        const response = await axios.get('https://bank2.daolog.net/users-by-contractor');
        setUsersByContractor(response.data);
        setLoading(false);
      } catch (error) {
        setError('Помилка при отриманні даних користувачів');
        setLoading(false);
      }
    };
  
    const handleSave = async (userId) => {
      try {
        setSaveError('');
        setSaveSuccess('');
        
        if (!newPassword) {
          setSaveError('Необхідно ввести новий пароль');
          return;
        }
        
        await axios.put(`https://bank2.daolog.net/update-user-adm/${userId}`, {
          newPassword: newPassword
        });
        
        setSaveSuccess('Пароль успішно оновлено');
        setNewPassword('');
        setEditingUser(null);
        fetchUsersGrouped();
      } catch (error) {
        setSaveError(error.response?.data?.message || 'Помилка при збереженні даних');
      }
    };

    const toggleContractor = (contractorName) => {
      setExpandedContractor(expandedContractor === contractorName ? null : contractorName);
    };

    const handleDeactivateContractor = async (contractorName) => {
      try {
        await axios.post(`https://bank2.daolog.net/deactivate-contractor`, {
          contractorName
        });
        fetchUsersGrouped();
      } catch (error) {
        setError('Помилка при деактивації користувачів');
      }
    };

    const handleActivateContractor = async (contractorName) => {
      try {
        await axios.post(`https://bank2.daolog.net/activate-contractor`, {
          contractorName
        });
        fetchUsersGrouped();
      } catch (error) {
        setError('Помилка при активації користувачів');
      }
    };
  
    if (loading) return <Typography>Завантаження...</Typography>;
    if (error) return <Typography color="error">{error}</Typography>;
  
    return (
      <div style={{ padding: "20px", maxWidth: "800px", margin: "0 auto", marginTop: "120px" }}>
        <Typography variant="h4" style={{ marginBottom: "20px" }}>Користувачі системи</Typography>
        
        {Object.entries(usersByContractor).map(([contractorName, users]) => {
          const isDeactivated = users.some(user => user.username.includes('_deactivated'));
          return (
          <div key={contractorName} style={{ marginBottom: "20px" }}>
            <Box 
              onClick={() => toggleContractor(contractorName)}
              style={{ 
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '10px',
                backgroundColor: '#f5f5f5',
                borderRadius: '4px'
              }}
            >
              <Typography variant="h5">
                {contractorName || 'Немає клієнта'} {isDeactivated ? '(Деактивовано)' : ''}
              </Typography>
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <button
                  className="download-button-s"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeactivateContractor(contractorName);
                  }}
                  disabled={isDeactivated}
                  style={{
                    opacity: isDeactivated ? 0.5 : 1,
                    cursor: isDeactivated ? 'not-allowed' : 'pointer'
                  }}
                >
                  Деактивувати
                </button>
                <button
                  className="download-button-g"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleActivateContractor(contractorName);
                  }}
                  disabled={!isDeactivated}
                  style={{
                    opacity: !isDeactivated ? 0.5 : 1,
                    cursor: !isDeactivated ? 'not-allowed' : 'pointer'
                  }}
                >
                  Активувати
                </button>
                {expandedContractor === contractorName ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </div>
            </Box>
            
            {expandedContractor === contractorName && users.map(userData => (
              <Card key={userData.id} style={{ marginBottom: "10px", marginTop: "10px" }}>
                <CardContent>
                  <Typography variant="h6">{userData.username}</Typography>
                  <Typography>Email: {userData.email}</Typography>
                  
                  {editingUser === userData.id ? (
                    <Box style={{ marginTop: "20px" }}>
                      <TextField
                        fullWidth
                        label="Новий пароль"
                        type="password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        margin="normal"
                      />
                      {saveError && (
                        <Alert severity="error" style={{ marginTop: "10px" }}>
                          {saveError}
                        </Alert>
                      )}
                      {saveSuccess && (
                        <Alert severity="success" style={{ marginTop: "10px" }}>
                          {saveSuccess}
                        </Alert>
                      )}
                      <div style={{ marginTop: "20px" }}>
                        <button
                          className="download-button-g"
                          onClick={() => handleSave(userData.id)}
                        >
                          Зберегти
                        </button>
                        <button
                          className="download-button-s"
                          onClick={() => setEditingUser(null)}
                          style={{ marginLeft: "10px" }}
                        >
                          Скасувати
                        </button>
                      </div>
                    </Box>
                  ) : (
                    <button
                      className="download-button"
                      onClick={() => setEditingUser(userData.id)}
                      style={{ marginTop: "10px" }}
                    >
                      Змінити пароль
                    </button>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        )})}
      </div>
    );
};

export default UserProfiles;